import { Component, OnInit } from '@angular/core';

import { Platform, NavController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AuthService } from './services/auth.service';
import { AlertService } from './services/alert.service';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  user: User;
  public selectedIndex = 0;
  public appPages = [
    {
      title: 'Home',
      url: '/dashboard',
      icon: 'home'
    },
    {
      title: 'Building Material',
      url: '/material',
      icon: 'code-download'
    },
    {
      title: 'Concrete',
      url: '/concrete',
      icon: 'code-download'
    },
    {
      title: 'Equipment',
      url: '/equipment',
      icon: 'code-download'
    },
    {
      title: 'Haul Off',
      url: '/hauloff',
      icon: 'code-download'
    },
    {
      title: 'Reports',
      url: '/reports/daily',
      icon: 'bar-chart'
    },
    {
      title: 'Security',
      url: '/security/attendance',
      icon: 'key'
    },
    {
      title: 'Workers',
      url: '/workers',
      icon: 'people'
    },
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private authService: AuthService,
    private navController: NavController,
    private alertService: AlertService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
//      this.authService.getToken();
    });
  }

  ngOnInit() {
    this.user = this.authService.getUser();
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }
  }

  logout() {
    this.authService.logout();
    this.navController.navigateRoot('/landing');
  }
}
